import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { AccordionModule } from "../shared/components/accordion/accordion.module";
import { FilterPipe } from "./filter.pipe";
import { FloatingFaqComponent } from "./floating-faq.component";

@NgModule({
    imports: [
        AccordionModule,
        FormsModule,
        CommonModule,
        MatButtonModule,
        MatIconModule
    ],
    exports: [
        FloatingFaqComponent
    ],
    declarations: [
        FloatingFaqComponent,
        FilterPipe
    ]
})

export class FloatingFaqModule {};
